// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1297a0ff","633":"1fe0430f"}[chunkId] + ".chunk.js";
};